import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';
import { CircleCtaSettings } from '../../typedefs/store';
import { circleCtaAnimation, styledWithProps } from '../../util/styles';

interface Props {
    ctaClicked: () => void;
    settings: CircleCtaSettings;
}

export default class CircleCta extends React.Component<Props, {}> {
    constructor(props: any) {
        super(props);
        this.ctaClicked = this.ctaClicked.bind(this);
    }

    ctaClicked(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.props.ctaClicked();
    }

    render() {
        const { settings } = this.props;

        return (
            <Positioner settings={settings} className="conversations-cta-circle">
                <Circle settings={settings} href="#" onClick={this.ctaClicked}>
                    {settings.ctaCustomImage ? (
                        <img src={settings.ctaCustomImage} />
                    ) : (
                        <ChatBubbleIcon size="50" />
                    )}
                </Circle>
            </Positioner>
        );
    }
}

const div = styledWithProps<{ settings: CircleCtaSettings }>(styled.div);

const Positioner = div`
    position: fixed;
    bottom: 20px;
    right: ${props => (props.settings.ctaPosition === 'bottom right' ? '20px' : 'auto')};
    left: ${props => (props.settings.ctaPosition === 'bottom left' ? '20px' : 'auto')};
    z-index: 1220000;
    ${circleCtaAnimation}
`;

const Circle = styledWithProps<{ settings: CircleCtaSettings }>(styled.a)`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.settings.ctaBackgroundColor};
    color: ${props => props.settings.ctaForegroundColor};
    transition: transform 0.15s ease-in;
    &:hover, &:active {
        color: ${props => props.settings.ctaForegroundColor};
        transform: scale(1.05);
    }
    border: 2px solid ${props => props.settings.ctaForegroundColor};
    overflow: hidden;
    img {
        max-width: 100%;
        max-height: 100%;
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Cta/Circle.tsx